module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-mobile-411x93.a0cf8014.webp";